"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@devsta/ui-kit");

function TabDrawer(_ref) {
  var children = _ref.children,
      setModal = _ref.setModal,
      hasUpdatePermission = _ref.hasUpdatePermission;
  return _react.default.createElement("div", {
    className: "storyboard-tab"
  }, _react.default.createElement("h3", null, "Script"), _react.default.createElement("div", {
    className: "storyboard-tab__script"
  }, children), _react.default.createElement(_uiKit.Button, {
    disabled: !hasUpdatePermission,
    small: true,
    onClick: setModal('import-script')
  }, "Import Script"));
}

var _default = TabDrawer;
exports.default = _default;